<template>
  <v-app :class="$style.wrapper">
    <v-app-bar absolute color="primary" dark class="px-d2">
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-list-item>
        <v-list-item-title>
          {{type === 'order' ? 'Заказ' : 'Трек'}} №{{ id }}
        </v-list-item-title>
      </v-list-item>
    </v-app-bar>
    <v-main>
      <v-container class="pa-0">
        <v-page-wrapper :class="$style.messagesWrapper">
          <MessagesList :id="id" :type="type" :class="$style.messages" />
        </v-page-wrapper>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import MessagesList from '@/components/MessagesList/MessagesList'

export default {
  name: 'index',
  components: {
    MessagesList,
  },
  setup(_, context) {
    const { id, type } = context.root.$route.query
    return {
      id: Number(id),
      type,
    }
  },
}
</script>

<style lang="scss" module>
.wrapper{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: $mobile-overlay-page-z-index;
  padding-bottom: $mobileToolbarHeight;

  :global(.v-app-bar) {
    top: 0;
    width: 100%;
    height: 6.4rem!important;
  }
  .messagesWrapper{
    display: flex;
    flex-direction: column;
    .messages{
      height: calc(100vh - #{$mobileToolbarHeight} - 4rem);
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  }
}
</style>
